import axios from "axios"
import {ExamAid} from "../types"

export const loadExamAids = async (authHeader: object): Promise<ExamAid[]> => {
    const response = await axios.get<ExamAid[]>("/api/eexam/aids", authHeader)
    return response.data
}

export const saveExamAid = async (data: Partial<ExamAid>, authHeader: object): Promise<ExamAid> => {
    if (data._id) {
        const response = await axios.put<ExamAid>(`/api/eexam/aids/${data._id}`, data, authHeader)
        return response.data
    }

    const response = await axios.post<ExamAid>("/api/eexam/aids", data, authHeader)
    return response.data
}

export const deleteExamAid = async (id: string, authHeader: object): Promise<void> => {
    await axios.delete(`/api/eexam/aids/${id}`, authHeader)
}
